import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {

    nuxtApp.provide('formatCurrency', (amount: string) => {
        return currencyFormat(amount);
    })
})
